import React, { Component } from 'react';
// import PropTypes from "prop-types";

import LoginForm from 'components/LoginForm';

export class LoginPage extends Component {
  render() {
    const { history, authStateChanged } = this.props;

    return (
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4">
            <h1 className="mb-3 text-center">Log in</h1>
            <LoginForm
              onAuthentication={({ token, user }) => {
                localStorage.setItem('token', token);
                authStateChanged({ user });
                history.push('/');
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
LoginPage.propTypes = {};

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js